import { TPepEntity, TRelatedPep } from './types';

export const defaultPepInfo: TRelatedPep = {
  fullName: null,
  identificationNumber: null,
  foreignTaxNumber: null,
  citizenshipCountry: { value: '804', label: 'Україна' },
  residenceCountry: { value: '804', label: 'Україна' },
  pepPosition: null,
  publicFunctionsStartDate: null,
  publicFunctionsEndDate: null,
};

export const emptyPep: TPepEntity = {
  fullName: '',
  pepInfo: null,
  familyPepsInfo: null,
  pepRelatedPersonsInfo: null,
  isPepsAbsent: false,
  isPep: false,
  isFamilyPep: false,
  isPepRelatedPerson: false,
  hasForeignTaxResidency: false,
  lastName: '',
  firstName: '',
  middleName: '',
  appeals: null,
  jurisdictions: null,
  accounts: null,
};

export enum PepSection {
  pepInfo = 'pepInfo',
  familyPepsInfo = 'familyPepsInfo',
  pepRelatedPersonsInfo = 'pepRelatedPersonsInfo',
}

export const IDENTIFICATION_NUMBER_LENGTH = 10;
export const FOREIGN_TAX_NUMBER_LENGTH = 15;
export const MAX_INPUT_LENGTH = 120;

export const typeAppeals = [
  { value: 'MR', label: 'Mr' },
  { value: 'DR', label: 'Dr' },
  { value: 'MS', label: 'Ms' },
  { value: 'HERR', label: 'Herr' },
];

export const reasonsIdentificationNumber = [
  {
    value: 'A',
    label:
      'Держава/юрисдикція, резидентом якої є Власник Рахунку, не видає номер платника податків своїм резидентам',
  },
  {
    value: 'B',
    label:
      'Власник Рахунку не може отримати номер платника податків або еквівалентний номер з інших причин (будь  ласка, ОБОВ’ЯЗКОВО вкажіть причину чому Ви не можете отримати)',
  },
  {
    value: 'C',
    label:
      'номер платника податків не вимагається (ОБОВ’ЯЗКОВО зазначте цю причину, тільки в тому  випадку, якщо національне законодавство відповідної юрисдикції не вимагає  збір номер платника податків, виданих цією юрисдикцією)',
  },
];

export const infoAccountTableColumns = [
  {
    title: 'Номер рахунку',
    size: 6,
  },
  {
    title: 'Дата відкриття рахунку',
    size: 5,
  },
];

export const JURISDICTION = {
  country: null,
  identifyCode: null,
  reason: null,
  explanation: null,
};

export const ACCOUNT = {
  iban: null,
  openDate: null,
};

export const testDataAdditionalInformationSoleTrader = {
  additionalInformation: [
    {
      type: 'SOLE_TRADER',
      fullName: 'Тарас Григорович Шевченко',
      pepInfo: {
        fullName: 'ЧЕЙПЕШ ЛАРИСА',
        identificationNumber: null,
        foreignTaxNumber: null,
        citizenshipCountry: { value: '804', label: 'Україна' },
        residenceCountry: { value: '804', label: 'Україна' },
        pepPosition: 'Економіст',
        publicFunctionsStartDate: '13.11.2008',
        publicFunctionsEndDate: null,
      },
      familyPepsInfo: [
        {
          fullName: 'Тарас Григорович Шевченко',
          identificationNumber: '1344388',
          foreignTaxNumber: null,
          citizenshipCountry: { value: '804', label: 'Україна' },
          residenceCountry: { value: '804', label: 'Україна' },
          pepPosition: 'Генеральний директор',
          publicFunctionsStartDate: '25.02.1937',
          publicFunctionsEndDate: null,
        },
      ],
      pepRelatedPersonsInfo: [],
      beneficiaryId: null,
      isPepsAbsent: false,
      isPep: true,
      isFamilyPep: true,
      isPepRelatedPerson: false,
      accounts: null,
      hasForeignTaxResidency: false,
      appeals: null,
      jurisdictions: null,
      lastName: null,
      firstName: null,
      middleName: null,
    },
  ],
};

export const testDataAdditionalInformationLegalResident = {
  additionalInformation: [
    {
      type: 'LEGAL_RESIDENT',
      fullName: 'Тарас Григорович Шевченко',
      pepInfo: {
        fullName: 'ЧЕЙПЕШ ЛАРИСА',
        identificationNumber: null,
        foreignTaxNumber: null,
        citizenshipCountry: { value: '804', label: 'Україна' },
        residenceCountry: { value: '804', label: 'Україна' },
        pepPosition: 'Економіст',
        publicFunctionsStartDate: '13.11.2008',
        publicFunctionsEndDate: null,
      },
      familyPepsInfo: [
        {
          fullName: 'Тарас Григорович Шевченко',
          identificationNumber: '1344388',
          foreignTaxNumber: null,
          citizenshipCountry: { value: '804', label: 'Україна' },
          residenceCountry: { value: '804', label: 'Україна' },
          pepPosition: 'Генеральний директор',
          publicFunctionsStartDate: '25.02.1937',
          publicFunctionsEndDate: null,
        },
      ],
      pepRelatedPersonsInfo: [],
      beneficiaryId: null,
      isPepsAbsent: false,
      isPep: true,
      isFamilyPep: true,
      isPepRelatedPerson: false,
      accounts: null,
      hasForeignTaxResidency: false,
      appeals: null,
      jurisdictions: null,
      lastName: null,
      firstName: null,
      middleName: null,
    },
  ],
};
